var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "groupbuy-order-pane" },
    [
      _c(
        "div",
        { staticClass: "status-tabs" },
        [
          _c(
            "el-radio-group",
            {
              attrs: { size: "small" },
              on: { change: _vm.handleStatusChange },
              model: {
                value: _vm.currentStatus,
                callback: function ($$v) {
                  _vm.currentStatus = $$v
                },
                expression: "currentStatus",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: null } }, [
                _vm._v("全部"),
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: 0 } }, [
                _vm._v("预支付"),
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: 1 } }, [
                _vm._v("已支付"),
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: 3 } }, [
                _vm._v("退款中"),
              ]),
              _vm._v(" "),
              _c("el-radio-button", { attrs: { label: 4 } }, [
                _vm._v("已退款"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "search-area" },
        [
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "流水号", clearable: "" },
                    model: {
                      value: _vm.searchForm.orderSn,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "orderSn", $$v)
                      },
                      expression: "searchForm.orderSn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("phone-user-select", {
                    staticStyle: { width: "220px" },
                    attrs: { placeholder: "买家手机号" },
                    on: { select: _vm.handlePhoneUserSelect },
                    model: {
                      value: _vm.searchForm.userId,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "userId", $$v)
                      },
                      expression: "searchForm.userId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "400px" },
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "下单开始时间",
                      "end-placeholder": "下单结束时间",
                      format: "yyyy-MM-dd HH:mm:ss",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      "default-time": ["00:00:00", "23:59:59"],
                    },
                    model: {
                      value: _vm.searchForm.dateRange,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "dateRange", $$v)
                      },
                      expression: "searchForm.dateRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [
                      _c("i", { staticClass: "el-icon-search" }),
                      _vm._v(" 查询\n        "),
                    ]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _c("i", { staticClass: "el-icon-refresh-left" }),
                    _vm._v(" 重置\n        "),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", loading: _vm.exportLoading },
                      on: { click: _vm.handleExport },
                    },
                    [
                      _c("i", { staticClass: "el-icon-download" }),
                      _vm._v(" 导出\n        "),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.tableLoading,
              expression: "tableLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "80", align: "center" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "会员信息",
              align: "left",
              width: "180",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "user-info-wrapper" },
                      [
                        _c("el-avatar", {
                          staticClass: "user-avatar",
                          attrs: {
                            src: _vm.getAvatarUrl(scope.row.userpic),
                            size: 40,
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "user-detail" }, [
                          _c("div", { staticClass: "user-name" }, [
                            _vm._v(_vm._s(scope.row.userAlias || "-")),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "user-mobile" }, [
                            _vm._v(_vm._s(scope.row.userMobile || "-")),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "user-rank" },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.getUserRankTagType(
                                      scope.row.userRank
                                    ),
                                    size: "mini",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.getUserRankName(scope.row.userRank)
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "类型", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.type === 4 || scope.row.type === 15
                      ? _c(
                          "el-tag",
                          { attrs: { type: "success", size: "small" } },
                          [_vm._v("套券")]
                        )
                      : scope.row.type === 5 || scope.row.type === 16
                      ? _c(
                          "el-tag",
                          { attrs: { type: "warning", size: "small" } },
                          [_vm._v("单品券")]
                        )
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "流水号/POS端",
              align: "left",
              width: "300",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.orderSn || "-"))]),
                    _vm._v(" "),
                    _c("div", { staticClass: "sub-text" }, [
                      _vm._v(_vm._s(scope.row.posOrderSn || "-")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "订单金额", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v("¥" + _vm._s(scope.row.totalAmount || 0))]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "购买内容", align: "left", "min-width": "320" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "items-wrap" },
                      [
                        _vm.activityImgUrl
                          ? _c("el-image", {
                              staticClass: "activity-image",
                              attrs: {
                                src: _vm.getImageUrl(_vm.activityImgUrl),
                                fit: "cover",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.items && scope.row.items.length
                          ? _c(
                              "div",
                              { staticClass: "items-list" },
                              _vm._l(scope.row.items, function (it, idx) {
                                return _c(
                                  "div",
                                  { key: idx, staticClass: "item-row" },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(it.name || "-")),
                                    ]),
                                    _vm._v(" "),
                                    it.buyMoney != null
                                      ? _c(
                                          "span",
                                          { staticClass: "item-price" },
                                          [_vm._v(" ¥" + _vm._s(it.buyMoney))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    it.num != null
                                      ? _c(
                                          "span",
                                          { staticClass: "item-num" },
                                          [_vm._v(" ×" + _vm._s(it.num))]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    it.isMissingId
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticClass: "item-status",
                                            attrs: {
                                              type: "danger",
                                              size: "mini",
                                            },
                                          },
                                          [_vm._v("发放id缺失")]
                                        )
                                      : it.isUsed
                                      ? _c(
                                          "el-tag",
                                          {
                                            staticClass: "item-status",
                                            attrs: {
                                              type: "success",
                                              size: "mini",
                                            },
                                          },
                                          [_vm._v("已使用")]
                                        )
                                      : _c(
                                          "el-tag",
                                          {
                                            staticClass: "item-status",
                                            attrs: {
                                              type: "info",
                                              size: "mini",
                                            },
                                          },
                                          [_vm._v("未使用")]
                                        ),
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _c("span", { staticClass: "items-empty" }, [
                              _vm._v("-"),
                            ]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "支付方式",
              prop: "payType",
              width: "120",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "状态", width: "110", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.payStatusTagType(scope.row.payStatus),
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.payStatusText(scope.row.payStatus)) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    scope.row.status != null
                      ? _c(
                          "div",
                          { staticClass: "status-order-line" },
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type: _vm.orderStatusTagType(
                                    scope.row.status
                                  ),
                                  size: "mini",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.orderStatusText(scope.row.status)
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "发票", width: "100", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.redPdfUrl
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "red" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDownloadInvoice(scope.row)
                              },
                            },
                          },
                          [_vm._v("已冲红")]
                        )
                      : scope.row.pdfUrl
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDownloadInvoice(scope.row)
                              },
                            },
                          },
                          [_vm._v("已开票")]
                        )
                      : _c("span", [_vm._v("--")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "拼团角色", width: "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.groupRole
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    scope.row.groupRole === 1 ? "danger" : "",
                                  size: "mini",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.groupRole === 1 ? "团长" : "团员"
                                  )
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "sub-text" }, [
                              _vm._v(_vm._s(scope.row.groupNo)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "sub-text" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.groupStatusText(scope.row.groupStatus)
                                ) +
                                  " " +
                                  _vm._s(scope.row.groupCurrentNum) +
                                  "/" +
                                  _vm._s(scope.row.groupLbNum) +
                                  "人"
                              ),
                            ]),
                          ],
                          1
                        )
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "下单/支付时间", align: "left", width: "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(_vm._s(_vm.formatTime(scope.row.createTime))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "sub-text" }, [
                      _vm._v(_vm._s(_vm.formatTime(scope.row.payTime))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "200",
              align: "center",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleView(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _vm._v(" "),
                    scope.row.payStatus === 1
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "#f56c6c" },
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleFullRefund(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          退款\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    scope.row.payStatus === 1
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { color: "#e6a23c" },
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDirectRefund(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n          部分退款\n        ")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-area" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "订单详情",
            visible: _vm.detailDialogVisible,
            width: "900px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _vm.currentRow
            ? _c("div", { staticClass: "detail-content" }, [
                _c("div", { staticClass: "info-section" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _vm._v("订单信息"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-body" }, [
                    _c("div", { staticClass: "info-row" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("流水号："),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.currentRow.orderSn || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("POS端号："),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.currentRow.posOrderSn || "-")),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-row" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("买家昵称："),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.currentRow.userAlias || "-")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("手机号："),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.currentRow.userMobile || "-")),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-row" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("订单金额："),
                        ]),
                        _c("span", { staticClass: "value price" }, [
                          _vm._v("¥" + _vm._s(_vm.currentRow.totalAmount || 0)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("支付方式："),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.currentRow.payType || "-")),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-row" }, [
                      _c(
                        "div",
                        { staticClass: "info-item" },
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("支付状态："),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.payStatusTagType(
                                  _vm.currentRow.payStatus
                                ),
                                size: "small",
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.payStatusText(_vm.currentRow.payStatus)
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("下单时间："),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(_vm.formatTime(_vm.currentRow.createTime))
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "info-row" }, [
                      _c("div", { staticClass: "info-item" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("支付时间："),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(
                            _vm._s(_vm.formatTime(_vm.currentRow.payTime))
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "info-section" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _vm._v("券码明细"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "section-body" },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.currentRow.items || [],
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "name",
                              label: "券名",
                              "min-width": "200",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "金额", width: "100" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "¥" + _vm._s(scope.row.buyMoney || 0)
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3819693085
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "发放id",
                              prop: "batchNo",
                              "min-width": "150",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "券码",
                              prop: "couponNo",
                              "min-width": "150",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "使用状态",
                              width: "120",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.isMissingId
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "danger",
                                                size: "small",
                                              },
                                            },
                                            [_vm._v("发放id缺失")]
                                          )
                                        : scope.row.isUsed
                                        ? _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "success",
                                                size: "small",
                                              },
                                            },
                                            [_vm._v("已使用")]
                                          )
                                        : _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type: "info",
                                                size: "small",
                                              },
                                            },
                                            [_vm._v("未使用")]
                                          ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1147933664
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "部分退款（仅退款，不退券）",
            visible: _vm.refundDialogVisible,
            width: "420px",
            "close-on-click-modal": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.refundDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: { "label-width": "100px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c("el-form-item", { attrs: { label: "订单号：" } }, [
                _c("span", [_vm._v(_vm._s(_vm.refundForm.orderSn || "-"))]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "可退金额：" } }, [
                _c("span", { staticClass: "price" }, [
                  _vm._v("¥" + _vm._s(_vm.refundForm.maxAmount || 0)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "退款金额：" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      min: 0.01,
                      max: _vm.refundForm.maxAmount,
                      precision: 2,
                      step: 0.01,
                      "controls-position": "right",
                    },
                    model: {
                      value: _vm.refundForm.money,
                      callback: function ($$v) {
                        _vm.$set(_vm.refundForm, "money", $$v)
                      },
                      expression: "refundForm.money",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.refundDialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.refundLoading },
                  on: { click: _vm.confirmDirectRefund },
                },
                [_vm._v("确认退款")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }